import { argon2Master, sodiumReady, type KdfParams } from './sodium';

interface Reply {
  id: number;
  master?: Uint8Array;
  error?: string;
}

let worker: Worker | null = null;
let counter = 0;

/**
 * Dérive la clé maîtresse dans un Worker quand le navigateur en offre ; sinon (tests, environnements
 * sans Worker) sur le fil courant. Le mot de passe ne quitte jamais l'appareil.
 */
export async function deriveMaster(password: string, params: KdfParams): Promise<Uint8Array> {
  if (typeof Worker === 'undefined') {
    await sodiumReady();
    return argon2Master(password, params);
  }
  worker ??= new Worker(new URL('./argon2.worker.ts', import.meta.url), { type: 'module' });
  const w = worker;
  const id = ++counter;
  return new Promise<Uint8Array>((resolve, reject) => {
    const onMessage = (event: MessageEvent<Reply>): void => {
      if (event.data.id !== id) return;
      w.removeEventListener('message', onMessage);
      if (event.data.master) resolve(event.data.master);
      else reject(new Error(event.data.error ?? 'échec de la dérivation'));
    };
    w.addEventListener('message', onMessage);
    w.postMessage({ id, password, params });
  });
}
